export default __webpack_public_path__ + "static/media/Conscript's Helm of the Watchtowers.f79791c9.jpg";